<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <PageTitle
                :title=titles.payment
                page="Paiement"
                v-if="showPageTitle"
        />
        <div class="card">
            <div class="row">
                <div class="col-6">
                    <div class="card-body">
                        <div class="col form-group">
                            <span class="e-ctl"><strong>Titulaire de la carte</strong></span>
                            <input class="form-control" id="cardholder-name" placeholder="Titulaire de la carte"
                                   type="text" v-model="nom">
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card-body">
                        <div class="col form-group">
                            <p class="detail-payment">Montant HT : {{price * nbreUser}} {{currency}}</p>
                            <p class="detail-payment" v-if="voucher>0">Coupons : {{voucher}}%</p>
                            <p class="detail-payment">TVA : {{tva}}%</p>
                            <p class="detail-payment">Montant TTC à payer : {{priceToPay * nbreUser}} {{currency}}</p>
                            <p class="detail-payment">Nombre d'utilisateur :

                                <button type="button" class="btn mb-3 mt-0"
                                        @click="minusNbreUser"><i
                                        class="fas fa-minus"></i></button>

                                <input type="number" class="input-custom-group input-unit"
                                       placeholder="1"
                                       v-model="nbreUser"/>

                                <button type="button" class="btn mb-3 mt-0" @click="addNbreUser"><i
                                        class="fas fa-plus"></i></button>
                            </p>


                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <div class="col form-group">
                            <span class="e-ctl"><strong>Numéro de la carte</strong></span>
                            <div class="form-control" id="card-element">
                            </div>
                            <div class="text-danger" id="card-errors" role="alert"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <div class="field remarque">
                            <button :disabled="isLoading||hasError"
                                    @click="payment(id)"
                                    class="btn btn-standard-gradient px-4 float-right mt-0 mb-3"
                                    type="button">
                                <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                                <i class="fas fa-cart-plus mr-2"></i>{{titles.paymentAdd}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-success :title="titles.successPayment" @messageFromModal="closeModal" id="success-payement"/>
        <modal-error :title="titles.errorPayment" id="error_payment" :subTitle="titles.cardNotSupported"/>
        <modal-error :title="titles.errorPayment" id="error_payment3DSecure" :subTitle="titles.card3DSecure"/>
        <modal-error :title="titles.errorPayment" id="error_paymentInsufficientFunds" :subTitle="titles.cardInsufficientFunds"/>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import {titles} from '../../utils/general/titles.js';
    import {name} from '../../utils/general/routers';
    import ModalSuccess from '../common/modal-success';
    import ModalError from '../common/modal-error.vue';
    import {addpayment, createCustomerStripe, getPublicKey} from '../shared/services/payment.service';
    import {updateSubscription} from '../shared/services/subscriptions.service';
    import PageTitle from '@/components/common/PageTitle';
    export default {
        name: 'payment',
        props: {
            showPageTitle: {
                type: Boolean,
                default: true
            }
        },
        components: {ModalSuccess, PageTitle, ModalError},
        mixins: [validationMixin],

        data() {
            return {
                titles,
                nom: null,
                stripe: '',
                elements: '',
                card: '',
                client_secret: '',
                cardholderName: '',
                path: ``,
                price: 0,
                tva: 0,
                voucher: 0,
                priceToPay: 0,
                currency: '',
                id: 0,
                isLoading: false,
                hasError: true,
                nbreUser: 1,
                stripePublicKey: null
            };
        },
        validations: {nom: {required}},
        created() {
            const user = this.$cookies.get('user');
            this.nom = user.firstName;
            if (this.$route.params.item) {
                this.$cookies.set('price', this.$route.params.item.price);
                this.$cookies.set('payedPrice', this.$route.params.item.payedPrice);
                this.$cookies.set('tva', this.$route.params.item.tva);
                this.$cookies.set('voucher', this.$route.params.item.voucher);
                this.$cookies.set('currency', this.$route.params.item.currency);
                this.$cookies.set('paymentItemId', this.$route.params.id);
            }
            if (this.$cookies.isKey('price') && this.$cookies.isKey('payedPrice') && this.$cookies.isKey('tva')
                && this.$cookies.isKey('voucher') && this.$cookies.isKey('currency')) {
                this.id = this.$cookies.get('paymentItemId');
                this.price = this.$cookies.get('price');
                this.priceToPay = this.$cookies.get('payedPrice');
                this.tva = this.$cookies.get('tva');
                this.voucher = this.$cookies.get('voucher');
                this.currency = this.$cookies.get('currency');
            }
        },
        mounted() {
            getPublicKey().then(response => {
                //   console.log(response)
                this.stripePublicKey = response.data;
                this.includeStripe('js.stripe.com/v3/', function () {
                    this.configureStripe();
                }.bind(this));
            });

        },
        methods: {
            minusNbreUser(){
                if(this.nbreUser>1){
                    this.nbreUser = this.nbreUser-1;
                }
            },
            addNbreUser(){
                this.nbreUser = this.nbreUser+1;
            },
            closeModal() {
                this.$router.push({name: name.organisationList});
            },
            includeStripe(URL, callback) {
                const documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
            configureStripe() {
                const _self = this;
                this.stripe = window.Stripe(this.stripePublicKey);

                this.elements = this.stripe.elements();

                this.cardholderName = document.getElementById('cardholder-name');
                this.card = this.elements.create('card');
                this.card.mount('#card-element');
                this.card.addEventListener('change', function (event) {
                    const displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                        _self.hasError = true;
                    } else {
                        displayError.textContent = '';
                        _self.hasError = false;
                    }
                });
            },
            payment() {
                this.isLoading = true;
                this.stripe.createSource(this.card, this.client_secret).then(this.getCarteAction);
            },
            getCarteAction(result){
                if(result.error){
                    this.$bvModal.show('error_payment');
                    this.isLoading = false;
                }else{
                    createCustomerStripe(this.id, result).then(responseCreateCustmor =>{
                        if(responseCreateCustmor.data == 'Your card has insufficient funds.'){
                            this.$bvModal.show('error_paymentInsufficientFunds');
                            this.isLoading = false;
                        }else{
                            addpayment(this.id , this.nbreUser, responseCreateCustmor.data)
                                .then(responsePayment => {
                                    this.achivePayment(responsePayment);
                                });
                        }
                    });
                }

            },
            achivePayment(result) {
                {
                    if (result.error) {
                        this.isLoading = false;
                        document.getElementById('card-errors').innerText = result.error.message;
                    } else {
                        if(result.data == 'Erreur 3D Secure'){
                            this.$bvModal.show('error_payment3DSecure');
                            this.isLoading = false;
                        }else{
                            updateSubscription(this.id).then(
                                response => {
                                    this.isLoading = false;
                                    this.$bvModal.show('success-payement');
                                    return response;
                                }
                            );
                        }

                    }
                }
            }
        }
    };
</script>
<style>
    @import '../../assets/style/css/base.css';
</style>